import React, { useEffect, useState } from 'react';

import { useAccaTestResultStore } from '@stores/AccaTestResultStore';
import ResultTab, { ResultMenuType } from './resultTab';
import ApplyResult from './applyResult';
import CompetencyResult from './competencyResult';
import DeepResult from './deepResult';
import { ResultStoreProvider } from './resultStoreProvider';
import { AnalysisType } from '@domain/constant/analysisType';

import classnames from 'classnames/bind';
import styles from './result.module.scss';
const cx = classnames.bind(styles);

const Result = () => {
  const [resultState, setResultState] = useState<AnalysisType | null>(null);
  const [resultMenu, setResultMenu] = useState<ResultMenuType>('APPLY');
  const accResult = useAccaTestResultStore((state) => state.accResult);

  const getResult = () => {
    switch (resultMenu) {
      // 응시 분석 결과
      case 'APPLY':
        return (
          <ApplyResult
            resultState={resultState}
            setResultState={setResultState}
            resultMenu={resultMenu}
            version={accResult?.version}
          />
        );
      // 역량 분석 결과
      case 'COMPETENCY':
        return <CompetencyResult resultMenu={resultMenu} version={accResult?.version} />;
      // 심층 분석 결과(v3만 해당)
      case 'DEEP':
        return <DeepResult />;
    }
  };

  // 다른 결과표 클릭시 첫번째 탭으로 이동.
  useEffect(() => {
    setResultMenu('APPLY');
  }, [accResult?.code]);

  if (!accResult) return null;

  return (
    <div className={cx('resultArea')}>
      {/* [D] 결과표 탭 영역 */}
      <ResultTab
        resultState={resultState}
        resultMenu={resultMenu}
        setResultMenu={setResultMenu}
        version={accResult.version}
      />

      {/* [D] 결과표 영역 */}
      <ResultStoreProvider isPublicStore={false}>{getResult()}</ResultStoreProvider>
    </div>
  );
};

export default Result;
